module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/bag-2-dea93161073520814e503aedd11fdcac.svg";